import request from '@/utils/http/axios'

const baseURL = import.meta.env.VITE_BASE_API_URL

// 获取数据字典
export const queryDictOptions = params => {
  return request.get({ url: `${baseURL}/sys/dict/list`, params })
}
